module.exports = __webpack_public_path__ + "img/ico_instagram.afac8448.png";